export interface SiteInfo {
  name: string;
  title: string;
  description: string;
  keywords: string;
  url: string;
  logo: string;
  foundingYear: string;
  contactEmail: string;
  socialLinks: {
    telegram: string;
    twitter: string;
    email: string;
  };
}

export const siteInfo: SiteInfo = {
  name: "caoliu 导航",
  title: "caoliu – 官方入口与完整使用指南",
  description: "本页围绕caoliu提供最权威的入口导航、功能介绍及使用指南，帮助用户快速找到caoliu官方地址、了解核心功能、掌握安全访问方法，是caoliu用户的必备参考页面。",
  keywords: "caoliu,caoliu官方入口,caoliu最新地址,caoliu使用指南,caoliu镜像,caoliu社区,caoliu导航",
  url: "https://caoliu-guide.com",
  logo: "caoliu 导航",
  foundingYear: "2018",
  contactEmail: "contact@caoliu-guide.com",
  socialLinks: {
    telegram: "https://t.me/caoliu_official",
    twitter: "https://twitter.com/caoliu_official",
    email: "mailto:contact@caoliu-guide.com",
  },
};